import React from "react";
import "../../assets/styles/components/textfield.scss";

interface Props {
  title?: string;
  rows?: number;
  placeholder?: string;
  className?: string;
  other?: boolean;
  readOnly?: boolean;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean
}

const Textarea: React.FC<Props> = ({
  placeholder,
  onChange,
  rows = 3,
  title,
  className = "",
  value,
  readOnly = false,
  disabled
}) => {
  return (
    <label className={`text-area ${className}`} htmlFor="text-area">
      <div style={{ marginBottom: "8px" }} className="title-input">
        {title}
      </div>
      <textarea
        id="text-area"
        rows={rows}
        className="col-12"
        placeholder={placeholder}
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        disabled={disabled}
      />
    </label>
  );
};
export default Textarea;
